import { Component, Input, OnInit } from '@angular/core';
import { FascicleRecord } from 'src/app/models/physical-record';
import { Util } from 'src/app/util';
import { groupBy } from '../../_core/utils/array-group-by';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fascicle-records-table',
  templateUrl: './fascicle-records-table.component.html',
  styleUrls: ['./fascicle-records-table.component.scss'],
})
export class FascicleRecordsTableComponent implements OnInit {
  private static readonly MAX_DESKTOP_ITEMS = 10;
  private static readonly MAX_MOBILE_ITEMS = 4;

  private currentPaginationPage = 0;

  pageSize = FascicleRecordsTableComponent.MAX_DESKTOP_ITEMS;

  isAllItemsDialogOpened = false;

  fasciclesByYear: [string, FascicleRecord[]][];
  fascicleRecordsDisplayList: [string, FascicleRecord[]][];

  @Input() recordTitle: string;
  @Input() fascicleAvailabilityItems: FascicleRecord[];

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.fasciclesByYear = Array.from(groupBy(this.fascicleAvailabilityItems, (item) => item.year));

    this.breakpointObserver.observe('(max-width: 1199px)').subscribe((breakpoint) => {
      // Mobile
      if (breakpoint.matches) {
        this.pageSize = FascicleRecordsTableComponent.MAX_MOBILE_ITEMS;
      } else { // Desktop
        this.pageSize = FascicleRecordsTableComponent.MAX_DESKTOP_ITEMS;
      }

      this.paginate();
    });
  }

  fasciclePage(pagination: any) {
    this.currentPaginationPage = pagination?.pageIndex * pagination.pageSize;
    this.paginate();
  }

  handleButtonClick(fascicle: FascicleRecord) {
    if (fascicle.link !== null && fascicle.link !== '') {
      window.open(fascicle.link, '_blank', 'noopener');
      return;
    }

    this.router.navigate(['/info', this.getExperienceLink(this.recordTitle, fascicle.recordId)]);
  }

  private paginate() {
    this.fascicleRecordsDisplayList = this.fasciclesByYear.slice(this.currentPaginationPage, this.currentPaginationPage + this.pageSize);
  }

  private getExperienceLink(recordTitle: string, recordId: string): string {
    return Util.slugify(recordTitle) + '-' + recordId;
  }
}
